import type { RouteRecordRaw, Router } from 'vue-router'

const PersonnelRoutes: RouteRecordRaw = {
  path: '/personnel',
  name: 'PersonnelModulePages',
  redirect: { name: 'PersonnelMainPages' },
  children: [
    {
      path: '',
      name: 'PersonnelMainPages',
      component: () => import('./views/ManagePersonnelView.vue'),
      meta: {
        title: 'personnel.personnels',
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(PersonnelRoutes)
}
